import React from 'react';
import { CellProps } from 'react-table';
import classNames from 'classnames';
import { IContract } from 'src/types/contract';
import styles from '../assets/contract-actions.module.scss';
import DeleteContractAction from './DeleteContractAction';
import SendContractAction from './SendContractAction';
import RemindContractAction from './RemindContractAction';

const ContractActionsColumn: React.FunctionComponent<CellProps<IContract>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IContract>) => (
    <div className={classNames(styles.actions)}>
        <DeleteContractAction data={original} />
        {original.statusDocusign == 1 ? (
            <SendContractAction data={original} />
        ) : original.statusDocusign == 2 ? (
            <RemindContractAction data={original} />
        ) : (
            <div />
        )}
        <div />
    </div>
);

export default ContractActionsColumn;
